var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnviseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.07,
    cy: 34.0696,
    rx: 34.07,
    ry: 34.0696,
    transform: "matrix(0.642766 -0.766063 0.766026 0.64281 0 52.1995)",
    fill: "#ADCAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1008 69.9049C72.9611 71.2632 71.2646 72.0162 69.4915 72.0113C58.1267 71.9797 46.7079 68.1168 37.3212 60.24C28.2897 52.6611 22.5907 42.5842 20.3869 31.8676C19.9841 29.9093 20.45 27.8649 21.7225 26.3228C21.7828 26.2498 21.8434 26.177 21.9044 26.1043C33.9988 11.6898 55.4879 9.80969 69.9016 21.9049C84.3152 34.0001 86.1952 55.4904 74.1008 69.9049V69.9049Z",
    fill: "#C4D9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.6042 42.3378C82.2279 46.0423 79.4387 49.3665 75.6824 49.3956C67.8675 49.456 59.9921 46.8423 53.5361 41.4248C47.0802 36.0073 43.1388 28.705 41.8412 20.998C41.2176 17.2935 44.0068 13.9692 47.7631 13.9402C55.578 13.8797 63.4534 16.4935 69.9093 21.911C76.3652 27.3284 80.3067 34.6307 81.6042 42.3378Z",
    fill: "#E5EEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnviseIcon);
export default __webpack_public_path__ + "static/media/envise-icon.031982229d1ed2e012f4c84a47533c83.svg";
export { ForwardRef as ReactComponent };